import { IApplicationContext } from 'shared/types/applicationContext';
import { EApplicationType } from 'shared/types/applicationType';
import { TApplicationState, TReduxStore } from 'shared/types/redux';
import { projectsListReducer, projectEditorReducer } from 'shared/reducers';
import { createReduxStore } from 'shared/utils/redux';

const ApplicationReducers = {
  [EApplicationType.ProjectsList]: projectsListReducer,
  [EApplicationType.ProjectEditor]: projectEditorReducer,
};

type TAdminType = EApplicationType.ProjectEditor | EApplicationType.ProjectsList;

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const {
    config,
    custom: { applicationType },
  } = context;

  const initialState = config.getStrict<TApplicationState>('initialState');

  const reducer = ApplicationReducers[applicationType as TAdminType];

  return createReduxStore(context, reducer, initialState, true);
}
